import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon, ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
const ROWS = [{
  before: '“Leemos la Biblia” es una pelea de todas las noches',
  after: 'Te la trae él y te pide “una historia más”'
}, {
  before: 'Escucha las historias sin entenderlas ni recordarlas',
  after: 'Te sorprende contándote quién fue Moisés, David, Ester'
}, {
  before: 'La pantalla siempre le gana a la Palabra',
  after: 'La pantalla se convierte en la puerta de entrada a la Palabra'
}, {
  before: 'Sientes culpa por no saber transmitir la fe',
  after: 'Sientes que estás sembrando algo que va a durar toda su vida'
}];
export function TransformationSection() {
  return <section className="w-full bg-mist" data-id="element-173" data-mp="295ym0lfe5255">
      <div className="mx-auto max-w-6xl px-4 py-5 md:py-6" data-id="element-174" data-mp="249hwpnwgghqh">
        <h2 className="mx-auto max-w-3xl text-center font-display text-3xl font-bold leading-tight text-deep-blue md:text-[40px]" data-id="element-175" data-mp="24b2vjppsymu5">
          Lo que cambia cuando la Biblia deja de ser una obligación
        </h2>

        <div className="mt-6 grid grid-cols-1 items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-2" data-id="element-176" data-mp="k1snig5c5q6r">
          {/* Antes */}
          <div className="rounded-card border border-card-border bg-white p-6 shadow-soft" data-id="element-177" data-mp="5do3n8ujr8me">
            <p className="mb-4 text-center text-sm font-bold uppercase tracking-wider text-ink/50" data-id="element-178" data-mp="abg6uz0n6h5w">
              Antes
            </p>
            <ul className="space-y-4" data-id="element-179" data-mp="y23erkak56sg">
              {ROWS.map(r => <li key={r.before} className="flex items-start gap-3" data-id="element-180" data-mp="12zlrzmvly869">
                  <XIcon className="mt-0.5 h-5 w-5 flex-none text-ink/40" aria-hidden="true" data-id="element-181" data-mp="p15l9vxqwho4" />
                  <span className="text-[16px] text-ink/70" data-id="element-182" data-mp="t0w8jpo2cfnw">{r.before}</span>
                </li>)}
            </ul>
          </div>

          {/* Divisor / flecha */}
          <div className="flex items-center justify-center" data-id="element-183" data-mp="3dtretokvbffh">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold text-white shadow-soft" data-id="element-184" data-mp="1k9pp6ox0deiv">
              <ArrowRightIcon className="hidden h-6 w-6 md:block" aria-hidden="true" data-id="element-185" data-mp="1famhsxtk2w7q" />
              <ArrowDownIcon className="h-6 w-6 md:hidden" aria-hidden="true" data-id="element-186" data-mp="1ajwavg5helax" />
            </span>
          </div>

          {/* Después */}
          <div className="rounded-card border border-gold/40 bg-deep-blue p-6 text-white shadow-soft" data-id="element-187" data-mp="15kjrx6hqdydm">
            <p className="mb-4 text-center text-sm font-bold uppercase tracking-wider text-gold" data-id="element-188" data-mp="11l2jc470cl48">
              Después
            </p>
            <ul className="space-y-4" data-id="element-189" data-mp="rlbqe6y3ie69">
              {ROWS.map(r => <li key={r.after} className="flex items-start gap-3" data-id="element-190" data-mp="rlk05pyx93d8">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold" aria-hidden="true" data-id="element-191" data-mp="mnikzg4m9o71" />
                  <span className="text-[16px] text-cream/95" data-id="element-192" data-mp="2h08cxsbfcnbs">{r.after}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <motion.blockquote initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mx-auto mt-6 max-w-2xl text-center" data-id="element-193" data-mp="2pgquz9wr0aeg">
          <p className="font-display text-2xl font-medium leading-snug text-deep-blue md:text-[28px]" data-id="element-194" data-mp="3396rrsz23c6x">
            <span className="text-gold" data-id="element-195" data-mp="26j66w51t5fuw">“</span>Tus hijos se están peleando por
            la Biblia... ¿cómo se castiga eso?<span className="text-gold" data-id="element-196" data-mp="2al1530ofzd4g">”</span>
          </p>
          <cite className="mt-3 block text-sm not-italic text-ink/60" data-id="element-197" data-mp="2fj2qhs9cboj3">
            — mensaje real de una abuela cuidando a sus nietos
          </cite>
        </motion.blockquote>
      </div>
    </section>;
}